export default "__VITE_ASSET__JOQnxN8K__"